import { type FC } from "react";
import { generatePath } from "react-router-dom";

import { cx } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";
import { CheckCircleIcon } from "@snapchat/snap-design-system-icons";

import { type Container } from "../../core/models";
import { AbsoluteRoute } from "../../core/routes/absoluteRoutes";
import { type ResourceContainer } from "../../gql-generated/types";
import { useSelectedFeature } from "../hooks/useSelectedFeature";
import { FEATURE_ORG_ROUTE_MAP, Feature, LENS_FOLDER_FEATURE_ROUTE_MAP } from "../models";
import { LinkStyled, menuLink, wordBreak } from "../styles";

import { ContainerNameHeader, checkmark, marginBottom } from "./ContainerDisplay.styles";

interface ContainerDisplayProps {
    container: Container | ResourceContainer;
    selectedContainerId: string;
    orgId: string;
    lensFolderId?: string;
}

export const ContainerDisplay: FC<ContainerDisplayProps> = ({
    container: { id, name },
    selectedContainerId,
    orgId,
    lensFolderId,
}) => {
    const { selectedFeature } = useSelectedFeature();

    let route: string;

    if (lensFolderId) {
        switch (selectedFeature) {
            case Feature.lenses: {
                route = generatePath(AbsoluteRoute.ORG_LENS_FOLDER_LENSES, {
                    orgId,
                    lensFolderId,
                });
                break;
            }
            default: {
                const folderRoute = selectedFeature ? LENS_FOLDER_FEATURE_ROUTE_MAP[selectedFeature] : undefined;
                route = generatePath(folderRoute ?? AbsoluteRoute.ORG_LENS_FOLDER, {
                    orgId,
                    lensFolderId,
                });
            }
        }
    } else {
        const orgRoute = selectedFeature ? FEATURE_ORG_ROUTE_MAP[selectedFeature] : undefined;
        route = orgRoute ? generatePath(orgRoute, { orgId }) : generatePath(AbsoluteRoute.ORG_LENS_FOLDERS, { orgId });
    }

    return (
        <li className={marginBottom}>
            <LinkStyled className={cx(menuLink, wordBreak)} to={route}>
                <ContainerNameHeader>{name}</ContainerNameHeader>
                {id === selectedContainerId && <CheckCircleIcon className={checkmark} fill={Colors.Green.V100} />}
            </LinkStyled>
        </li>
    );
};
